var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Logging out ...")]),_c('vue-simple-spinner',{staticClass:"g-mt-100 g-mb-100"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }